import { bufferTime } from "rxjs/operators";

export const grpcDataBuffer = <T>() => bufferTime<T>(240);
